import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';

import { createReduxStore, IAppState, IStoreContext } from '../../../shared/store';

export function createApplicationState() {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();

  const initialState = config.getStrict<IAppState>('initialState');

  const context: IStoreContext = {
    config,
    httpApi,
    logger,
  };

  return createReduxStore(context, initialState, true);
}
